// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZeGVk","newExpiryDate":"styles_newExpiryDate__2i996","footer":"styles_footer__3_20y"};